export const CODEC_VERSION = "v1";
export const CORPUS_ID = "cn-1";
export const TITLE = `〔诗帖 ${CODEC_VERSION}·${CORPUS_ID}〕`;

export const RHYME_BITS = 4;
export const WITHIN_CLASS_BITS = 17;
export const LINE_BITS = RHYME_BITS + WITHIN_CLASS_BITS;
export const RHYME_CLASS_COUNT = 1 << RHYME_BITS;
export const LINES_PER_CLASS = 1 << WITHIN_CLASS_BITS;
export const TOTAL_LINES = RHYME_CLASS_COUNT * LINES_PER_CLASS;

export const ARGON2_MEMORY_BYTES = 64 * 1024 * 1024;
export const ARGON2_OPS_LIMIT = 3;
export const KEY_BYTES = 32;
export const FEISTEL_ROUNDS = 8;
export const MAX_MESSAGE_BYTES = 65_535;

export function payloadBitsForLine(lineNumber: number): number {
  if (lineNumber < 1 || !Number.isInteger(lineNumber)) {
    throw new RangeError("Line numbers are one-based positive integers.");
  }
  return lineNumber === 2 || lineNumber % 2 === 1 ? LINE_BITS : WITHIN_CLASS_BITS;
}

export function capacityBits(lineCount: number): number {
  let total = 0;
  for (let line = 1; line <= lineCount; line += 1) total += payloadBitsForLine(line);
  return total;
}

export function minimumLineCount(messageByteLength: number): number {
  if (!Number.isInteger(messageByteLength) || messageByteLength < 0 || messageByteLength > MAX_MESSAGE_BYTES) {
    throw new RangeError(`Message length must be between 0 and ${MAX_MESSAGE_BYTES} bytes.`);
  }
  const required = messageByteLength * 8 + 1;
  let lines = 0;
  let capacity = 0;
  while (capacity < required || lines % 2 === 1) {
    lines += 1;
    capacity += payloadBitsForLine(lines);
  }
  return lines;
}

export function rhymeClassOf(index: number): number {
  return index >>> WITHIN_CLASS_BITS;
}

export function withinClassIndexOf(index: number): number {
  return index & (LINES_PER_CLASS - 1);
}
